import { useTranslation } from 'react-i18next'
import { TPatientReviewStatsResponse } from './reviews.types'
import { LoadingSpinner, CurecallButton } from '@honestica/curecall-ui'
import PageTitle from 'src/components/page-title/page-title.component'

export type Props = {
  isLoading: boolean
  patientReviewStats: TPatientReviewStatsResponse | undefined
  onExport: VoidFunction
}

export default function PatientReviewHeader({ isLoading, patientReviewStats, onExport }: Readonly<Props>) {
  const { t } = useTranslation()

  return (
    <div className="c-mb-4">
      <PageTitle>{t('pages.patient-review.title')}</PageTitle>
      <div className="c-flex c-items-end c-justify-between c-m-0">
        <ul className="c-flex c-font-semibold c-flex-col c-gap-2 [&>li>span]:c-text-secondary-800 [&>li>span]:c-mx-2 [&>li>span]c-text-xl">
          {isLoading && <LoadingSpinner />}
          {!isLoading && patientReviewStats && (
            <>
              <li>
                {t('pages.patient-review.average-value')}
                <span>{patientReviewStats.averageOfNumberValues}</span>
              </li>
              <li>
                {t('pages.patient-review.total-form-count')}
                <span>{patientReviewStats.totalPatientFormCount}</span>
              </li>
              <li>
                {t('pages.patient-review.form-count')}
                <span>{patientReviewStats.patientFormCompletedCount}</span>
              </li>
              <li>
                {t('pages.patient-review.sent-to-google')}
                <span>{patientReviewStats.patientSentToGoogleCount}</span>
              </li>
              <li>
                {t('pages.patient-review.completed-form-ratio')}
                {}
                <span>{patientReviewStats.patientFormCompletedRatio}%</span>
              </li>
            </>
          )}
        </ul>
        <CurecallButton onClick={onExport}>{t('pages.patient-review.modal-cta')}</CurecallButton>
      </div>
    </div>
  )
}
